import React, { useState, memo } from 'react';
import { Paper, Stack, Box, Typography, Chip, Button, Collapse, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { INotificationLogResponse } from 'services/GeneralLogs/NotificationLogService/types';
import { COLORS } from './Constants';
import { getPlatformIcon, formatToLocalTime } from '../helpers';

const {
  tableBackgroundColor,
  borderColorDarkTheme,
  fontColorDarkTheme
} = COLORS;

const errorBoxStyles = {
  backgroundColor: 'rgba(211, 47, 47, 0.1)', 
  border: '1px solid #d32f2f', 
  color: '#ffb4ab', 
  px: 1, py: 0.5, borderRadius: 1,
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
  whiteSpace: 'pre-wrap',
  maxWidth: '100%',
};

const MobileCard = ({ row }: { row: INotificationLogResponse }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Paper sx={{ backgroundColor: tableBackgroundColor, border: `1px solid ${borderColorDarkTheme}`, borderRadius: 2, p: 2 }}>
      <Stack spacing={1}>
        
        {/* CABEÇALHO DO CARD */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
          <Typography variant="caption" sx={{ color: 'gray', fontFamily: 'monospace' }}>
            {formatToLocalTime(row.createdAt)}
          </Typography>
          <Chip 
            label={row.isSuccess ? t('notificationLogs.status.success') : t('notificationLogs.status.failure')}
            size="small"
            color={row.isSuccess ? 'success' : 'error'}
            variant={row.isSuccess ? 'outlined' : 'filled'}
            sx={{ fontWeight: 'bold', fontSize: '10px', borderRadius: '4px' }} 
          />
        </Box>

        {/* PLATAFORMA */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {getPlatformIcon(row.platform)}
          <Typography variant="body2" sx={{ color: fontColorDarkTheme }}>
            {row.platform}
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ color: fontColorDarkTheme }}>
          {row.subjectName || t('common.unknown')}
        </Typography>

        {/* BOTÃO DE AÇÃO */}
        <Button
          size="small"
          onClick={() => setOpen(!open)}
          sx={{ textTransform: 'none', color: '#58a6ff', alignSelf: 'flex-start' }}
        >
          {open ? t('notificationLogs.actions.hideDetails') : t('notificationLogs.actions.viewDetails')}
        </Button>

        {/* ÁREA EXPANDIDA */}
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Divider sx={{ my: 1, borderColor: borderColorDarkTheme }} />
          <Stack spacing={1}>
            <Box>
              <Typography variant="caption" sx={{ color: 'gray' }}>{t('notificationLogs.details.faceRecognitionEventId')}</Typography>
              <Typography variant="body2" sx={{ color: fontColorDarkTheme }}>{row.faceRecognitionEventId}</Typography>
            </Box>

            <Box>
              <Typography variant="caption" sx={{ color: 'gray' }}>{t('notificationLogs.details.recipients')}</Typography>
              <Typography variant="body2" sx={{ color: fontColorDarkTheme }}>{row.recipients}</Typography>
            </Box>

            <Box>
              <Typography variant="caption" sx={{ color: 'gray' }}>{t('notificationLogs.details.subjectType')}</Typography>
              <Typography variant="body2" sx={{ color: fontColorDarkTheme }}>{row.subjectType}</Typography>
            </Box>

            {row.errorMessage && (
              <Box sx={errorBoxStyles}>
                <Typography variant="caption" sx={{ color: '#ffb4ab' }}>{t('notificationLogs.details.errorMessage')}</Typography>
                <Typography variant="body2">{row.errorMessage}</Typography>
              </Box>
            )}
          </Stack>
        </Collapse>
        
      </Stack>
    </Paper>
  );
};

export default memo(MobileCard);